
// src/components/common/FormField.js
import React from 'react';

const FormField = ({ id, label, type, value, onChange, placeholder, required = false, autoComplete }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-content-secondary">
      {label}
    </label>
    <div className="mt-1">
      <input
        id={id}
        name={id}
        type={type}
        autoComplete={autoComplete}
        required={required}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="block w-full px-3 py-2 bg-background-secondary border border-border rounded-md shadow-sm placeholder-content-secondary focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
      />
    </div>
  </div>
);

export default FormField;
